"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.setUpdatedPostalCodeInCachedLocation = exports.setCachedLocation = exports.getValuesByTypeGooglePlaceResults = exports.getStateCodeFromGooglePlaceResults = exports.getPostalCodeFromGooglePlaceResults = exports.getLocalityFromGooglePlaceResults = exports.getFormattedAddresFromGooglePlaceResults = exports.getCityFromGooglePlaceResults = exports.getCachedLocation = exports.bindGoogleAutocompleteToInput = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var USER_LOCATION_CACHE_KEY = 'cSL_uL';
var defaultState = {
  searchValue: '',
  userLocation: null,
  stateCode: ''
};
var localStorage = typeof window !== 'undefined' && window.localStorage;
var getStateCodeFromGooglePlaceResults = function getStateCodeFromGooglePlaceResults(results) {
  var _results$0$address_co;
  return (_results$0$address_co = results[0].address_components.find(function (addressComponent) {
    return addressComponent.types.some(function (type) {
      return type === 'administrative_area_level_1';
    });
  })) == null ? void 0 : _results$0$address_co.short_name;
};
exports.getStateCodeFromGooglePlaceResults = getStateCodeFromGooglePlaceResults;
var getLocalityFromGooglePlaceResults = function getLocalityFromGooglePlaceResults(results) {
  return (results.find(function (result) {
    return result.types[0] === 'locality';
  }) || {}).formatted_address;
};
exports.getLocalityFromGooglePlaceResults = getLocalityFromGooglePlaceResults;
var getValuesByTypeGooglePlaceResults = function getValuesByTypeGooglePlaceResults(results, type) {
  var value;
  for (var i = 0; i < results.length; i++) {
    for (var j = 0; j < results[i].address_components.length; j++) {
      for (var k = 0; k < results[i].address_components[j].types.length; k++) {
        if (results[i].address_components[j].types[k] === type) {
          value = results[i].address_components[j].short_name;
        }
      }
    }
  }
  return value;
};
exports.getValuesByTypeGooglePlaceResults = getValuesByTypeGooglePlaceResults;
var getCityFromGooglePlaceResults = function getCityFromGooglePlaceResults(results) {
  return getValuesByTypeGooglePlaceResults(results, 'locality');
};
exports.getCityFromGooglePlaceResults = getCityFromGooglePlaceResults;
var getFormattedAddresFromGooglePlaceResults = function getFormattedAddresFromGooglePlaceResults(results) {
  return (results.find(function (result) {
    return result.formatted_address;
  }) || {}).formatted_address;
};
exports.getFormattedAddresFromGooglePlaceResults = getFormattedAddresFromGooglePlaceResults;
var getPostalCodeFromGooglePlaceResults = function getPostalCodeFromGooglePlaceResults(results) {
  return getValuesByTypeGooglePlaceResults(results, 'postal_code');
};
exports.getPostalCodeFromGooglePlaceResults = getPostalCodeFromGooglePlaceResults;
var bindGoogleAutocompleteToInput = function bindGoogleAutocompleteToInput(input, market, onPlaceChange) {
  var country = market === 'language-masters' ? 'gb' : market;
  var autocomplete = new window.google.maps.places.Autocomplete(input, {
    types: ['(regions)'],
    componentRestrictions: {
      country: country
    }
  });
  autocomplete.addListener('place_changed', function () {
    onPlaceChange(input.value);
  });
};
exports.bindGoogleAutocompleteToInput = bindGoogleAutocompleteToInput;
var getCachedLocation = function getCachedLocation() {
  if (!localStorage || !localStorage.getItem(USER_LOCATION_CACHE_KEY)) {
    return defaultState;
  }
  return JSON.parse(localStorage.getItem(USER_LOCATION_CACHE_KEY));
};
exports.getCachedLocation = getCachedLocation;
var setCachedLocation = function setCachedLocation(data) {
  if (!localStorage) {
    return;
  }
  if (data) {
    return localStorage.setItem(USER_LOCATION_CACHE_KEY, JSON.stringify(data));
  }
  localStorage.removeItem(USER_LOCATION_CACHE_KEY);
};
exports.setCachedLocation = setCachedLocation;
var setUpdatedPostalCodeInCachedLocation = function setUpdatedPostalCodeInCachedLocation(postalCode) {
  if (!localStorage) {
    return;
  }
  if (postalCode) {
    var currentData = JSON.parse(localStorage.getItem(USER_LOCATION_CACHE_KEY));
    var updatedData = _objectSpread(_objectSpread({}, currentData), {}, {
      postalCode: postalCode
    });
    return localStorage.setItem(USER_LOCATION_CACHE_KEY, JSON.stringify(updatedData));
  }
  localStorage.removeItem(USER_LOCATION_CACHE_KEY);
};
exports.setUpdatedPostalCodeInCachedLocation = setUpdatedPostalCodeInCachedLocation;